import { useSelector } from 'react-redux';

/**
 * Returns the URL prefix for the current user based on userType.
 * e.g. 'creator' or 'influencer' (defaults to 'influencer').
 */
const useUserPrefix = () => {
  const userType = useSelector((state) => state.user?.data?.userType);
  if (userType === 'creator') return 'creator';
  return 'influencer';
};

/**
 * Returns the URL prefix for a given userType string (for use outside React components).
 */
export const getUserPrefix = (userType) => {
  if (userType === 'creator') return 'creator';
  return 'influencer';
};

export default useUserPrefix;
